import Swiper, { Navigation, Autoplay, Pagination } from 'swiper'

Swiper.use([Navigation, Autoplay, Pagination])

function initContentCarousels() {

  const contentCarouselBlocks = Array.from(document.querySelectorAll('.js-content-carousel'))

  contentCarouselBlocks.forEach(contentCarouselBlock => {
    const contentCarouselSwiper = contentCarouselBlock.querySelector('.js-content-carousel-swiper')

    const slides = Array.from(contentCarouselBlock.querySelectorAll('.js-content-carousel-slide'))

    if (slides.length > 1) {
      const paginationEl = contentCarouselBlock.querySelector('.js-content-carousel-pagination')
      const navPrevEl = contentCarouselBlock.querySelector('.js-content-carousel-nav-prev')
      const navNextEl = contentCarouselBlock.querySelector('.js-content-carousel-nav-next')

      const swiper = new Swiper(contentCarouselSwiper, {
        loop: true,
        speed: 800,
        grabCursor: true,
        spaceBetween: 24,
        autoplay: {
          delay: 8000
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        navigation: {
          prevEl: navPrevEl,
          nextEl: navNextEl,
        },
      })

      //stop autoplay on mouseover
      contentCarouselSwiper.addEventListener('mouseover', () => {
        swiper.autoplay.stop()
      })

      //start autoplay on mouseout
      contentCarouselSwiper.addEventListener('mouseout', () => {
        swiper.autoplay.start()
      })
    }
  })
}
initContentCarousels()
